export default __webpack_public_path__ + "static/uCall x Spa_page-0002-b829b50e41367fbf7438b6aab56ab8d4.jpg";